import { Message, Modal } from "grabcad-ui-elements";
import { GridColumn, Button, GridRow, Segment, Card, Label, Icon } from "semantic-ui-react";
import styled from "styled-components";

export const CenteredGridColumn = styled.div`
    flex: 0; /* Prevents auto-expanding */
    white-space: nowrap; /* Ensures text doesn’t wrap if unnecessary */
    padding: 0 20px; /* Optional padding for spacing */
    text-align: center;
    p {
        color: #858585; /* Apply gray color to <p> tags only */
        margin-bottom: 5px; /* Add equal spacing between each <p> */
    }
`;

export const SideGridColumn = styled(GridColumn)`
    flex: 1; /* Side columns take equal space */
`;

export const CenteredDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const PurpleText = styled.span`
    color: #700ac1;
`;
export const PurpleHeading = styled.h3`
    color: #700ac1;
`;

export const PurpleBullet = styled.li`
    &::marker {
        color: #700ac1;
    }
    margin-bottom: 12px; /* Adds spacing between bullet points */
    line-height: 1.5; /* Ensures consistent text spacing */
    list-style-type: disc; /* Keeps default bullet styling */
`;

export const TopContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    height: 240px;
    line-height: 1.4;
    overflow: hidden;
    box-sizing: border-box;
`;

export const ScrollableList = styled.div`
    flex: 1; /* 🔑 takes remaining height */
    overflow-y: auto; /* scroll only when needed */
    overflow-x: hidden;
    box-sizing: border-box;
    padding-right: 6px; /* avoids scrollbar overlap */
`;

export const CentreContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    height: 180px;
    line-height: 1.5;
    overflow: hidden;
    box-sizing: border-box;
`;

export const BottomContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    height: 220px;
    line-height: 1.5;
    overflow: hidden;
    box-sizing: border-box;
`;

export const StyledUl = styled.ul`
    margin-top: 0;
    padding-left: 30px;

    & > li {
        margin-bottom: 12px; /* Adds space after each bullet point */
    }
`;

export const PurpleButton = styled(Button)`
    background-color: #700ac1 !important;
    color: white !important;
    opacity: 1 !important; /* Remove the opacity for better visibility */
    max-height: 40px;
    padding: 10px 20px; /* Optional: Add some padding for better button size */
    border-radius: 4px; /* Optional: Rounded corners */
    border: none; /* Optional: Remove border for cleaner look */
    transition: background-color 0.3s ease; /* Smooth transition on hover */

    &:hover {
        background-color: #5b0099 !important; /* Darker purple shade on hover */
    }
`;

export const EqualHeightRow = styled(GridRow)`
    display: flex !important;
    align-items: stretch;
`;

export const NoPrinterMessage = styled(Message)`
    display: flex !important;
    align-items: stretch;
    text-align: center;
    max-width: 600px;
`;
export const AnalyzeSaasModalMessage = styled(Message)`
    text-align: center;
`;

export const AnalyzeSaasModal = styled(Modal)`
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    padding: 0;
`;

export const AnalyzeSaasModalContainer = styled.div`
    width: 100%;
    max-height: 80vh;
    padding: 24px 32px;
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 24px;

    overflow-y: auto; /* scroll if content is too tall */
    box-sizing: border-box;
`;

export const AnalyzeSaasModalButtonsWrapper = styled.div`
    display: flex;
    justify-content: center; /* center horizontally */
    gap: 16px;
    flex-shrink: 0; /* prevent shrinking when modal scrolls */
`;

export const EmptyColumn = styled.div`
    flex: 1; /* This ensures it takes equal space */
`;

export const ComparisonCardWrapper = styled.div`
    flex: 0 1 auto; /* Allows content to adjust based on its size */
    max-width: 100%; /* Prevents it from exceeding available space */
    padding: 20px;
`;

export const CardColumn = styled(GridColumn)`
    display: flex;
    align-items: stretch;
    min-width: 370px; /* Ensures it doesn’t shrink too much */
    padding: 16px;
`;

export const FullHeightSegment = styled(Segment)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh; /* Full viewport height */
    padding: 40px 20px;
    gap: 24px;
`;

export const InlineTable = styled.table`
    border-collapse: collapse;
`;

export const InlineTableCell = styled.td`
    vertical-align: middle;
    padding-right: 0.5rem;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-height: 50px;
    margin: 20px 0 35px 0;
    max-height: 400px;
    overflow-y: auto;
    width: 100%;
`;

export const FixedTopChild = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const AnalyzeConfigInfoContainer = styled.div`
    display: table;

    .formRow {
        display: table-row;
        table-layout: fixed;
    }

    .tableCell {
        display: table-cell;
        vertical-align: bottom;
    }

    .buttonGroup {
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
`;

export const ConfigureAnalyzeSaasPageCard = styled("div")`
    margin: 1em 0;
    width: 100%;
    height: 100%;
`;

export const PrinterList = styled("div")`
    top: 70px;
    position: relative;
    width: 100%;
`;

export const PrinterTableContainer = styled("div")`
    overflow-y: auto;
    max-height: 300px;
    width: 100%;
`;

export const PrinterTable = styled("table")`
    border: 0;
`;

export const PrinterTableHeader = styled("thead")`
    position: sticky;
    top: 0;
    z-index: 1;
`;

export const PrinterRow = styled("tr")`
    &:nth-child(odd) {
        background-color: #ffffff;
    }

    &:nth-child(even) {
        background-color: rgb(142, 142, 142, 0.15);
        color: #5c5c5c;
    }
`;

export const LabelPrinter = styled(Label)`
    background-color: #700ac1 !important;
    color: #ffffff !important;
    width: 28;
    height: 14;
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0px;
    position: relative;
    opacity: 0.8;
`;

export const FooterButtonContainer = styled.div`
    position: relative;
    width: 100%;
    bottom: 35px;
    top: 110px;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

export const GreenCheckmark = styled(Icon)`
    margin-left: 10px;
    position: relative;
    top: 5px;
`;

export const GreenCheckmarkText = styled("span")`
    position: relative;
    top: 5px;
    color: #31bd40;
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
`;

export const CircularProgressIndicators = styled("div")`
    display: flex;
    top: 35px;
    position: relative;
    align-items: baseline;
    flex-flow: row;
    gap: 30px;
`;

export const CircularProgressIndicatorsCard = styled(Card)`
    border-radius: 12px;
    padding: 20px;
    background-color: #f5f5f5;
    height: 120px;
    width: 225px !important;
    border: 1px solid rgb(245, 245, 245, 0.2);
`;

export const InnerCardContentDiv = styled("div")`
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
`;

export const ProgressIndicatorOuterSegment = styled(Segment)`
    width: 96px !important;
    height: 96px !important;
    border-radius: 50% !important;
    border: 10px solid rgb(112, 10, 193, 0.3) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-right: 10px !important;
    position: relative !important;
`;

export const ProgressIndicatorInnerSegment = styled(Segment)`
    width: 85px !important;
    height: 85px !important;
    border-radius: 50% !important;
    border: 8px solid rgb(112, 10, 193, 0.5) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    position: relative !important;
`;

export const GeneralTextFields = styled("p")`
    width: 110px;
    height: 48px;
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #7951eb;
    margin: 0;
    position: relative;
    top: -5px;
    line-spacing: 0.2px;
`;

export const TotalCounter = styled("span")`
    font-family: Open Sans;
    font-size: 42px;
    line-height: 74px;
    font-weight: 700;
    color: #7951eb;
    position: relative;
`;

export const TotalPrintersStatement = styled("h3")`
    font-family: Roboto;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
`;

export const AnalyzeSaaSTagTableCell = styled("span")`
    display: grid;
    grid-template-columns: 0.7fr 0.4fr;
    justify-items: start;
`;

export const EllipsisText = styled("span")`
    white-space: nowrap;
    overflow: hidden;
`;

export const HoverText = styled("div")`
    position: relative;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    display: none;
    bottom: 100%;

    ${EllipsisText}:hover & {
        display: block;
        width: 200px;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    display: flex; /* NOT inline-flex */
    justify-content: center;
    align-items: center;
`;

export const Inner = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PurpleButtonText = styled.div`
    color: #700ac1;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    text-decoration: underline;
    text-transform: capitalize;
    line-height: 16px;
    letter-spacing: 1.25px;
    word-wrap: break-word;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

export const ModalWrapper = styled.div`
    width: 540px; /* fixed width */
    max-height: 500px !important;
    background: white;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 12px;
    overflow-y: auto;
`;

export const ModalContent = styled.div`
    align-self: stretch;
    padding: 24px 24px 0 24px;
    background: white;
    border-radius: 20px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    display: flex;
`;

export const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* ensures children align to the left */
    text-align: left; /* ensures text itself aligns left */
    width: 100%;
`;

export const Title = styled.div`
    align-self: stretch;
    color: #181d27;
    font-size: 16px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    line-height: 28px;
    word-wrap: break-word;
`;

export const FooterContent = styled.div`
    align-self: stretch;
    padding: 0 24px 24px 24px;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 12px;
    display: inline-flex;
`;

export const CloseActionButton = styled.div`
    flex: 1 1 0;
    padding: 10px 18px;
    background: #7951eb;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    overflow: hidden;
    border-radius: 8px;
    outline: 1px #7951eb solid;
    outline-offset: -1px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    display: flex;
    cursor: pointer;
`;

export const CloseButtonText = styled.div`
    color: white;
    font-size: 16px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    line-height: 24px;
    word-wrap: break-word;
`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5); /* semi-transparent background */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* ensure it's on top */
`;

export const StyledList = styled.ul`
    list-style-position: outside;
    padding-left: 20px; /* Adjust indentation as needed */
    margin: 0;
`;

export const StyledListItem = styled.li`
    margin-bottom: 12px;
    color: #535862;
    font-size: 14px;
    font-family: Inter;
    line-height: 20px;
    text-align: left;

    strong {
        font-weight: 700;
        color: #181d27;
    }
`;
